export const LANGUAGES = ['en', 'uk'];
export const DEFAULT_LANGUAGE = 'uk';

export const NAMESPACE = ['auth', 'menu', 'validation', 'common'];
export const DEFAULT_NS = 'auth';